<div class="app-update">
  <div class="app-update-icon">
    <ion-icon name="sync-outline"></ion-icon>
  </div>

  <h2 class="app-update-title">En ny versjon av Connect er tilgjengelig</h2>
  <p class="app-update-text">
    Oppdater nå for å få de nyeste funksjonene og forbedringene.
  </p>

  <div class="app-update-actions">
    <ion-button fill="outline" color="medium" (click)="later()">
      Ikke nå
    </ion-button>
    <ion-button (click)="install()">
      <ion-icon name="download-outline" slot="start"></ion-icon>
      Installer
    </ion-button>
  </div>
</div>
